import React from 'react'
import { AiFillCheckCircle } from 'react-icons/ai';

const AdCategorie: React.FC = () => {
  return (
    <div className='w-full flex justify-center font-Poppins bg-white rounded-lg p-8 flex-col gap-8 shadow-md'>
      <div className="flex flex-col">
        <div className="flex gap-2 items-center">
          <AiFillCheckCircle className='fill-green-500'/>
          <h1 className='text-[#555] font-semibold text-lg'>Campaign name</h1>
        </div>

        <div className="pl-6 pr-12 text-sm font-normal text-[#555] mt-[10px]">
          Declare if your ads are related to credit, 
          employment or housing, or about social issues, 
          election or politics. Requirements differ by country. <span className='text-xs text-midGreen'>Learn more</span>
        </div>

        <div className="pl-6 flex flex-col pr-12 justify-start gap-2 mt-8">
          <h1 className='text-[#555] font-semibold text-lg'>Campaign name</h1>
          <input 
            type="text"
            placeholder='No categories declared'
            className='w-full h-11 pl-5 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
        </div>

        <div className="flex flex-col mt-8 gap-3">
          <div className="flex gap-2 items-center">
            <AiFillCheckCircle className='fill-green-500'/>
            <h1 className='text-[#555] font-semibold text-lg'>
              Campaign details
            </h1>
          </div>
          <div className="flex pl-6 pr-12 flex-col gap-2">
            <h1 className='text-midGreen font-semibold text-base'>
              Buying type
            </h1>
            <input 
              type="text"
              placeholder='No categories declared'
              className='w-full h-11 pl-5 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
            />
          </div>
       </div>
      </div>
    </div>
  )
}

export default AdCategorie;